function t(t,e=[]){if(void 0===t)return{};const n={};return Object.keys(t).filter((n=>n.match(/^on[A-Z]/)&&"function"==typeof t[n]&&!e.includes(n))).forEach((e=>{n[e]=t[e]})),n}export{t as default};
//# sourceMappingURL=extractEventHandlers.js.map
